var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { SchedulerActionButtons } from './SchedulerActionButtons';
import { Form } from '@progress/kendo-vue-form';
import { Dialog as KendoDialog } from '@progress/kendo-vue-dialogs';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { SchedulerFormEditor } from '../editors/SchedulerFormEditor';
import { messages, editorValidationRequired, editorValidationStart, editorValidationEnd, editorSave, editorCancel, editorTitle } from '../messages/main';
import { getTemplate, guid } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var SchedulerFormVue2 = {
  name: 'KendoSchedulerForm',
  // @ts-ignore
  emits: {
    cancel: null,
    close: null,
    submit: null
  },
  props: {
    dataItem: Object
  },
  inject: {
    ks: {
      default: null
    },
    kendoLocalizationService: {
      default: null
    },
    ksValidator: {
      default: null
    },
    ksModifyInitialFormValues: {
      default: null
    }
  },
  created: function created() {
    this.dialogId = guid();
  },
  data: function data() {
    return {
      media: 'desktop'
    };
  },
  mounted: function mounted() {
    var that = this;
    that.calculateMedia();
    setTimeout(function () {
      var dialogWrapper = document.getElementById(that.dialogId);
      if (dialogWrapper) {
        dialogWrapper.focus();
      }
    }, 10);
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;
    var h = gh || createElement;
    var that = this;
    var localization = provideLocalizationService(this);
    this.requiredValidationMessage = localization.toLanguageString(editorValidationRequired, messages[editorValidationRequired]);
    this.endValidationMessage = localization.toLanguageString(editorValidationEnd, messages[editorValidationEnd]);
    var editSaveMessage = localization.toLanguageString(editorSave, messages[editorSave]);
    var editCancelMessage = localization.toLanguageString(editorCancel, messages[editorCancel]);
    var editorTitleMessage = localization.toLanguageString(editorTitle, messages[editorTitle]);
    this.startValidationMessage = localization.toLanguageString(editorValidationStart, messages[editorValidationStart]);
    var renderAs;
    var defaultRendering =
    // @ts-ignore  function children
    h(SchedulerFormEditor, this.v3 ? function () {
      return [h(SchedulerActionButtons, {
        editSaveMessage: editSaveMessage,
        attrs: _this.v3 ? undefined : {
          editSaveMessage: editSaveMessage,
          editCancelMessage: editCancelMessage
        },
        editCancelMessage: editCancelMessage,
        onCancel: _this.handleCancel,
        on: _this.v3 ? undefined : {
          "cancel": _this.handleCancel
        }
      })];
    } : [h(SchedulerActionButtons, {
      editSaveMessage: editSaveMessage,
      attrs: _this.v3 ? undefined : {
        editSaveMessage: editSaveMessage,
        editCancelMessage: editCancelMessage
      },
      editCancelMessage: editCancelMessage,
      onCancel: _this.handleCancel,
      on: _this.v3 ? undefined : {
        "cancel": _this.handleCancel
      }
    })]);
    renderAs = getTemplate.call(this, {
      h: h,
      template: this.ks.form,
      defaultRendering: defaultRendering,
      additionalProps: {
        dataItem: this.dataItem,
        editSaveMessage: editSaveMessage,
        editCancelMessage: editCancelMessage
      },
      additionalListeners: {
        cancel: this.handleCancel
      }
    });
    var dialogProps = __assign({
      title: editorTitleMessage,
      appendTo: 'body',
      minWidth: this.media === 'desktop' ? 600 : '85%',
      wrapperId: this.dialogId
    }, this.ks.dialogProps);
    var formProps = __assign({
      initialValues: that.ksModifyInitialFormValues(that.$props.dataItem),
      validator: that.formValidator
    }, this.ks.formProps);
    return h(KendoDialog, __assign({
      attrs: this.v3 ? undefined : dialogProps,
      onClose: this.handleClose,
      on: this.v3 ? undefined : {
        'close': this.handleClose
      },
      'class': 'k-scheduler-edit-dialog'
    }, dialogProps), this.v3 ? function () {
      return [h(Form, __assign({
        attrs: that.v3 ? undefined : formProps,
        onSubmit: that.handleSubmit,
        on: that.v3 ? undefined : {
          'submit': that.handleSubmit
        }
      }, formProps), that.v3 ? function () {
        return [renderAs];
      } : [renderAs])];
    } : [h(Form, __assign({
      attrs: this.v3 ? undefined : formProps,
      onSubmit: this.handleSubmit,
      on: this.v3 ? undefined : {
        'submit': this.handleSubmit
      }
    }, formProps), this.v3 ? function () {
      return [renderAs];
    } : [renderAs])]);
  },
  methods: {
    calculateMedia: function calculateMedia() {
      this.media = window.matchMedia('(min-width: 600px)').matches ? 'desktop' : 'mobile';
    },
    handleCancel: function handleCancel(event) {
      this.$emit('cancel', {
        value: null,
        event: event,
        target: this.form
      });
    },
    handleClose: function handleClose(_a) {
      var event = _a.event;
      this.$emit('close', {
        value: null,
        event: event,
        target: this.form
      });
    },
    handleSubmit: function handleSubmit(dataItem, event) {
      this.$emit('submit', {
        value: dataItem,
        event: event,
        target: this.form
      });
    },
    startAfterEndValidator: function startAfterEndValidator(value, formValueGetter) {
      return Boolean(value && formValueGetter(this.ks.fields.end) && value.getTime() > formValueGetter(this.ks.fields.end).getTime()) ? this.startValidationMessage : undefined;
    },
    endAfterStartValidator: function endAfterStartValidator(value, formValueGetter) {
      return Boolean(value && formValueGetter(this.ks.fields.start) && value.getTime() < formValueGetter(this.ks.fields.start).getTime()) ? this.endValidationMessage : undefined;
    },
    requiredValidator: function requiredValidator(value) {
      return value ? undefined : this.requiredValidationMessage;
    },
    formValidator: function formValidator(_dataItem, formValueGetter) {
      var result = {};
      result[this.ks.fields.start] = [this.requiredValidator(formValueGetter(this.ks.fields.start)), this.startAfterEndValidator(formValueGetter(this.ks.fields.start), formValueGetter)].filter(Boolean).reduce(function (current, acc) {
        return current || acc;
      }, '');
      result[this.ks.fields.end] = [this.requiredValidator(formValueGetter(this.ks.fields.start)), this.endAfterStartValidator(formValueGetter(this.ks.fields.start), formValueGetter)].filter(Boolean).reduce(function (current, acc) {
        return current || acc;
      }, '');
      var additionalValidator = this.ksValidator(formValueGetter);
      return __assign(__assign({}, result), additionalValidator);
    }
  }
};
/**
 * @hidden
 */
var SchedulerForm = SchedulerFormVue2;
export { SchedulerForm, SchedulerFormVue2 };